module.exports = __webpack_public_path__ + "img/53.2cd78044.png";